import React, { useState, useEffect } from 'react';
import { Tabs, TabHeader, TabPanel } from '@wk/components-react16';
import { logUserActivity, Toast, UserActivity } from '../../services';
import { API_USER } from '../../core/constants';
import Api from '../../core/api';
import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';

const AccessManagement = () => {
  const [roleList, setRoleList] = useState([])
  const [isLoad, setIsLoad] = useState(true)
  const getRoles = () => {
    Api.getRequest(API_USER.GET_ROLES).then(
      (res: any) => {
        const list = res.map((item: any) => ({ ...item, label: item.name, isSelected: false, privilegeString: item.privileges?.map((i: any) => i.name).join(', ') }));
        setRoleList(list)
      },
      (err: any) => {
        Toast(err.message, "error")
      },
    )
  }

  const handleActivity = (event: any) => {
    let userActivity: UserActivity = {
      action: 'Tab Click',
      page: 'Access Management',
      viewName: event == 0 ? 'User Management' : 'Role Management',
    }
    logUserActivity(userActivity);
  }

  useEffect(() => {
    if (isLoad) {
      getRoles();
      setIsLoad(false);
    }
  }, [isLoad])

  return (
    <div>
      <h4>Access Management</h4>
      <Tabs mode="default" onUserRequest={(event: any) => handleActivity(event)}>
        <TabHeader slot="tabHeader">User Management</TabHeader>
        <TabHeader slot="tabHeader">Role Management</TabHeader>
        <TabPanel slot="tabPanel">
          <UserManagement roleList={roleList} />
        </TabPanel>
        <TabPanel slot="tabPanel">
          <RoleManagement roleList={roleList} setIsLoad={setIsLoad} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default AccessManagement;
